/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Tall_Quail_WadeInputs */

const en_warm_tall_quail_wade = /** @type {(inputs: Warm_Tall_Quail_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter employee ID...`)
};

const de_warm_tall_quail_wade = /** @type {(inputs: Warm_Tall_Quail_WadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalnummer eingeben...`)
};

/**
* | output |
* | --- |
* | "Enter employee ID..." |
*
* @param {Warm_Tall_Quail_WadeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_tall_quail_wade = /** @type {((inputs?: Warm_Tall_Quail_WadeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Tall_Quail_WadeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_tall_quail_wade(inputs)
	return de_warm_tall_quail_wade(inputs)
});